import { Popconfirm } from 'antd';
import { ButtonTheme, ButtonToolTip } from '../../../../components';
import {
  createColumnButtonArr,
  createColumnDate,
  createColumnNumber,
  createColumnTag,
  createColumnText,
  formatNumber,
  widthOptions,
} from '../../../../components/table/function';
import { WARRANTY_STATUS } from '../../../../resources/status';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import React from 'react';
import {
  getWarrantyBrandsDisplayLines,
  getWarrantyModelsDisplayLines,
} from '../utils/warrantyMobilesDisplay';

const renderWarrantyBrands = (_t, record) => {
  const lines = getWarrantyBrandsDisplayLines(record);
  if (!lines) {
    return record.mobileBrandName ?? '';
  }
  return lines.join(', ');
};

const renderWarrantyModels = (_t, record) => {
  const lines = getWarrantyModelsDisplayLines(record);
  if (!lines) {
    return record.mobileModelName ?? '';
  }
  return lines.join(', ');
};

export const columns = ({ handleDelete }) => {
  return [
    createColumnTag(
      'สถานะ',
      { key: 'warrantyStatus', text: 'warrantyStatus', icon: true },
      WARRANTY_STATUS,
    ),
    createColumnText('เลขที่รับประกัน', 'warrantyCode', widthOptions(150)),
    createColumnText('ชื่อ-นามสกุล', 'fullName', widthOptions(150)),
    createColumnText('ชื่อไลน์', 'lineName', widthOptions(120)),
    createColumnText('เบอร์ติดต่อ', 'telephone', widthOptions(150)),
    createColumnText('รหัสสินค้า', 'itemCode', widthOptions(210)),
    createColumnText('ชื่อสินค้า', 'productName', widthOptions(150)),
    createColumnText('บาร์โค้ด', 'warrantyNumberCode', widthOptions(160)),
    createColumnText(
      'ยี่ห้อ',
      'mobileBrandName',
      widthOptions(100, { render: renderWarrantyBrands }),
    ),
    createColumnText(
      'รุ่น',
      'mobileModelName',
      widthOptions(150, { render: renderWarrantyModels }),
    ),
    createColumnText('ช่องทางการซื้อ', 'channelBuyName', widthOptions(150)),
    createColumnDate('วันที่ลงทะเบียน', 'createDate', widthOptions(170)),
    createColumnDate('วันหมดอายุ', 'expireDate', widthOptions(150)),
    createColumnNumber(
      'วันคงเหลือ',
      'remainingDays',
      widthOptions(150, {
        render: (value) => {
          if (value > 300000) {
            return <div>ตลอดชีวิต</div>;
          } else {
            return formatNumber(value);
          }
        },
      }),
    ),
    createColumnButtonArr('จัดการ', 'rowNo', {
      others: {
        fixed: 'right',
        width: 170,
      },
      buttonArr: [
        {
          useFor: (record) => (record.warrantyStatus === 'CLAIMING' ? 'DETAIL' : 'EDIT3'),
          render: (text, record) => {
            if (record.warrantyStatus === 'COMPLETED') {
              return (
                <ButtonToolTip toolTip="ดูรายละเอียด">
                  <ButtonTheme
                    useFor="DETAIL"
                    onClick={() => {
                      const url = `${ROUTES_PATH.ROUTE_WARRANTY_VIEW.PATH}?code=${record.warrantyCode}`;
                      window.open(url, '_blank');
                    }}
                  />
                </ButtonToolTip>
              );
            }
            return (
              <ButtonToolTip toolTip="แก้ไข">
                <ButtonTheme
                  useFor="EDIT2"
                  onClick={() => {
                    const url = `${ROUTES_PATH.ROUTE_WARRANTY_EDIT.PATH}?code=${record.warrantyCode}`;
                    window.open(url, '_blank');
                  }}
                />
              </ButtonToolTip>
            );
          },
        },
        {
          useFor: 'DELETE',
          render: (text, record) => {
            if (record.warrantyStatus !== 'ACTIVE') {
              return null;
            }
            return (
              <ButtonToolTip toolTip="ยกเลิกรับประกัน" placement="topLeft">
                <Popconfirm
                  title="คุณต้องการยกเลิกการรับประกันหรือไม่?"
                  onConfirm={() => handleDelete(record)}
                  okText="ใช่"
                  cancelText="ไม่"
                >
                  <ButtonTheme useFor="DELETE" />
                </Popconfirm>
              </ButtonToolTip>
            );
          },
        },
      ],
    }),
  ];
};

export const exportHeaders = [
  { dataIndex: 'warrantyCode', title: 'เลขที่รับประกัน' },
  { dataIndex: 'warrantyNumberCode', title: 'บาร์โค้ด' },
  { dataIndex: 'categoryCode', title: 'หมวดหมู่' },
  { dataIndex: 'warrantyStatus', title: 'สถานะ' },
  { dataIndex: 'mobileBrandName1', title: 'ยี่ห้อ (1)' },
  { dataIndex: 'mobileBrandName2', title: 'ยี่ห้อ (2)' },
  { dataIndex: 'mobileBrandName3', title: 'ยี่ห้อ (3)' },
  { dataIndex: 'mobileModelName1', title: 'รุ่น (1)' },
  { dataIndex: 'mobileModelName2', title: 'รุ่น (2)' },
  { dataIndex: 'mobileModelName3', title: 'รุ่น (3)' },
  { dataIndex: 'itemCode', title: 'รหัสสินค้า' },
  { dataIndex: 'productName', title: 'ชื่อสินค้า' },
  { dataIndex: 'channelBuyName', title: 'ช่องทางการซื้อ' },
  { dataIndex: 'fullName', title: 'ชื่อ-นามสกุล' },
  { dataIndex: 'telephone', title: 'เบอร์โทร' },
  { dataIndex: 'email', title: 'อีเมลล์' },
  { dataIndex: 'createDate', title: 'วันที่ลงทะเบียน' },
  { dataIndex: 'claimCode', title: 'เลขที่เคลม' },
  { dataIndex: 'claimRemark', title: 'สาเหตุการเคลม' },
  { dataIndex: 'claimDate', title: 'วันที่เคลม' },
  { dataIndex: 'expireDate', title: 'วันหมดอายุ' },
  { dataIndex: 'warrantyStatusName', title: 'สถานะการลงทะเบียน' },
  { dataIndex: 'lineUid', title: 'lineUid' },
];
